import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import Common from "../../helper/common";
import { Button } from "../../components/ui/button";
import AdvanceTable from "../../components/advanceTable";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "../../contexts/queryParamsContext";
import { SearchTypeEnum } from "../../constants/appConstant";

const Clubs = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const navigate = useNavigate();
  const { params, setParams } = useQueryParams();
  useEffect(() => {
    getData(1);
  }, []);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    setLoading(true);
    const response = await Common.ApiService.getInstance().request(
      "GetClubsList",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: null,
        countryId: null,
        cityId: null,
        stateId: null,
        //isapproved: true,
        isapproved: null,
        isPaid: null,
        recordsToDisplay,
      },
      "Post"
    );
    debugger;
    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          facilities: item.facilities
            ? item.facilities
                .map((facility) => facility.masterFacilityName)
                .join(", ")
            : "",
        })),
      };

      setData(obj);
      setLoading(false);
    }
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this Club?",
      "Delete Club"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteClub?clubId=${id}`,
        {},
        "Delete"
      );
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };
  const actions = [
    {
      type: "edit",
      onClick: (val) => {
        setParams({
          ...params,
          clubId: val.id,
        });
        navigate(`/app/ClubSetups`);
      },
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  let columns = [
    { title: "Club Id", type: "number", key: "id", isVisible: false},
    { title: "Club Name", type: "text", key: "name" },
    { title: "City", type: "date", key: "cityName" },
    { title: "Contact #", type: "text", key: "phone" },
    { title: "Postal Code", type: "text", key: "postalCode" },
    { title: "Starting From", type: "text", key: "startFrom" },
    /* { title: "Facilities", type: "text", key: "facilities" },*/
    {
      title: "Is Active",
      type: "toggle",
      isVisible: true,
      key: "isactive",
      // onChanged: _onIsOnMobileChange,
    },
  ];

  const _addBtn = () => (
    <Button onClick={() => navigate("/app/ClubSetups")}>
      <span className="text-xl mr-1">
        <Icon icon="icon-park-outline:plus" />
      </span>
      Add
    </Button>
  );

  return (
    <>
      {data?.data && (
        <AdvanceTable
          title={"Clubs"}
          columns={columns}
          data={data}
          getData={getData}
          showPagination
          showAddButton
          updateTrigger={_addUpdateTrigger}
          actionButtons={actions}
          addButton={_addBtn}
          search={SearchTypeEnum.Server_Search}
          searchInputClassName="custom-search-mobile "

          // updateTrigger={(id) => global.log("Update triggered for id:", id)} // Example function
        />
      )}
    </>
  );
};

export default Clubs;
